import { render, staticRenderFns } from "./BaseChipsBasic.vue?vue&type=template&id=064657e9"
import script from "./BaseChipsBasic.vue?vue&type=script&lang=js"
export * from "./BaseChipsBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports